const T = require('prop-types');
const FallbackSpinner = require('./fallback-spinner');

module.exports = function DelayedFallbackSpinner(props) {

    const {
        delay = 500,
        message = 'Loading...'
    } = props;

    return <FallbackSpinner delay={delay} message={message} />;
};

module.exports.propTypes = {
    delay: T.number,
    message: T.string
};
